import { API, graphqlOperation, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import SpareDocumentForm from "components/spares/documents/SpareDocumentForm";
import { updateSpareDocument } from "graphql/mutations";
import { getSpareDocument } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const SpareDocumentUpdateForm = ({ spareDocumentId, onSuccess }) => {
  const navigate = useNavigate();
  const [spareDocument, setSpareDocument] = useState();
  const [loading, setLoading] = useState(false);

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = spareDocument.fileSrc;

      if (fileObj !== spareDocument.fileSrc) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`spares/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });

        await Storage.remove(`spares/${spareDocument.fileSrc}`, {
          level: "public",
        });
      }

      await API.graphql({
        query: updateSpareDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            id: spareDocumentId,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/spares");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchSpareDocument(id) {
    try {
      const spareDocumentData = await API.graphql(
        graphqlOperation(getSpareDocument, { id })
      );
      const spareDocumentItem =
        spareDocumentData.data.getSpareDocument;
      if (!spareDocumentItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/spares");
        return;
      }
      setSpareDocument({
        ...spareDocumentItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchSpareDocument(spareDocumentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spareDocumentId]);

  if (!spareDocument) return <Loader />;

  return (
    <div>
      <SpareDocumentForm
        onSubmit={onSubmit}
        type="update"
        initialValues={spareDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Documento de Repuesto",
    successUpdated: "Documento de Repuesto actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el documento de repuesto",
    },
  },
});

export default SpareDocumentUpdateForm;
